import { connect } from 'react-redux'
import { TileComponent } from './TileComponent'
import type { Dispatch } from 'redux'
import { push } from 'connected-react-router'
import type { RootState } from 'shared/store/reducers'

const mapStateToProps = (state: RootState) => {
    const { products } = state.ecommerceOrderState

    return { cartProducts: products }
}

const mapDispatchToProps = (d: Dispatch<any>) => ({
    navigate: (to: string, state?: any) => d(push({ pathname: to, state }))
})

const Tile = connect(mapStateToProps, mapDispatchToProps)(TileComponent)

export { Tile }
